import { loaderAction } from "../const";

export const displayLoader = (data: any) => {
    return {
        type: loaderAction.GET_LOADER,
        payload: data,
    };
};
